import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { Amplify } from "aws-amplify";
import {environment} from "./environments/environment";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.awsConfig.userPoolId,
      userPoolClientId: environment.awsConfig.userPoolClientId,
      identityPoolId: environment.awsConfig.identityPoolId
    },
  },
});

const currentConfig = Amplify.getConfig();
bootstrapApplication(
  AppComponent, appConfig
).catch(err => console.error(err));
